export const SHOW_MORE_OVERFLOW_TEXT_WIDTH = 62;
export const SHOW_MORE_ITEMS_GAP = 3;
